import React from 'react';
import './ServiceCard.css';

const ServiceCard = ({ service, delay = 0 }) => {
  const IconComponent = () => {
    switch (service.icon_class) {
      case 'FaCode':
        return <i className="fas fa-code"></i>;
      case 'FaPaintBrush':
        return <i className="fas fa-paint-brush"></i>;
      case 'FaServer':
        return <i className="fas fa-server"></i>;
      default:
        return <i className="fas fa-cog"></i>;
    }
  };

  return (
    <div className="service-card" data-aos="fade-up" data-aos-delay={delay}>
      <div className={`service-icon ${service.color}`}>
        <IconComponent />
      </div>
      <h3>{service.title}</h3>
      <p>{service.description}</p>
    </div>
  );
};

export default ServiceCard;